import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToast } from 'context/providers/ToastProvider';
import { Button, Card, Col, Collapse, Row, Spinner } from 'react-bootstrap';
import AgregarProducto from './AgregarProducto';



const DetalleProducto = () => {

    const { id } = useParams();
    const { showErrorToast } = useToast();
    const { token, setToken } = useToken();
    const [producto, setProducto] = useState({});
    const [precios, setPrecios] = useState([]);
    const [tabMonedaDetalle, setTabMonedaDetalle] = useState('MXN');
    const [editar, setEditar] = useState(false)
    const [cargando, setCargando] = useState(true);
    const navigate = useNavigate();
    const [imagenProducto, setImagenProducto] = useState({
        file: null,
        fileName: ''
    });
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');
    const [activeSection, setActiveSection] = useState(null);


    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        informacionDetalladaProducto();
    }, []);


    /**
    * Divide dCreatedDate en fecha y hora por separados
    */
    useEffect(() => {
        if (producto?.dCreatedDate) {
            const [fechaParte, horaParte] = producto.dCreatedDate.split("T");
            const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const [año, mes, dia] = fechaParte.split("-");
            setFecha(`${parseInt(dia)} ${meses[parseInt(mes) - 1]} ${año}`); // Guardar la fecha formateada
            setHora(horaParte.split(".")[0]); // Guardar la hora (eliminando los milisegundos)
        }
    }, [producto?.dCreatedDate]);

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        // Validar si no hay imagen
        if (!base64String) return null;

        try {
            // Extraer el contenido Base64 de manera segura
            const base64Data = base64String?.split(',')[1] || base64String;

            // Validar formato Base64
            if (!/^[A-Za-z0-9+/=]*$/.test(base64Data)) {
                console.error('Formato Base64 inválido');
                return null;
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const mimeType = base64String.split(';')[0]?.split(':')[1] || 'image/jpeg';

            return new File([new Blob([byteArray], { type: mimeType })], fileName, {
                type: mimeType,
                lastModified: Date.now()
            });

        } catch (error) {
            console.error('Error al convertir Base64 a File:', error);
            return null;
        }
    };

    /**
     * obtiene informacion de un producto
     */
    const informacionDetalladaProducto = async () => {

        setCargando(true);

        const jDataSend = JSON.stringify({ idProducto: id });
        const headers = {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        };

        try {
            const [resDetalle, resPrecios] = await Promise.all([
                fetch('/api/Productos/DetalleProducto', { method: 'POST', headers, body: jDataSend }),
                fetch('/api/Productos/ObtenerPreciosProducto', { method: 'POST', headers, body: jDataSend })
            ]);

            if (!resDetalle.ok) {
                if (resDetalle.status === 401) { setToken(null); location.href = ''; return; }
                showErrorToast(resDetalle.status + ' ' + resDetalle.statusText);
                return;
            }

            const dataDetalle = await resDetalle.json();
            if (dataDetalle.iResponseType == 1) {
                const ObjDetalles = JSON.parse(dataDetalle.detalles);
                setProducto(ObjDetalles.table2?.[0] ?? {});

                const file_jpg = ObjDetalles.table2[0]?.vImagenProducto_Base64
                    ? base64ToFile(
                        ObjDetalles.table2[0].vImagenProducto_Base64,
                        ObjDetalles.table2[0].vImagenProducto_Name
                    )
                    : null;
                setImagenProducto({
                    fileName: ObjDetalles.table2[0]?.vImagenProducto_Name || 'sin-imagen',
                    file: file_jpg ? URL.createObjectURL(file_jpg) : null
                });
            } else {
                showErrorToast(dataDetalle.vMessage);
            }

            if (resPrecios.ok) {
                const dataPrecios = await resPrecios.json();
                if (dataPrecios.iResponseType == 1) {
                    const ObjPrecios = JSON.parse(dataPrecios.detalles);
                    const preciosArray = Array.isArray(ObjPrecios.table2)
                        ? ObjPrecios.table2
                        : Object.values(ObjPrecios.table2 || {});
                    setPrecios(preciosArray);
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
        } finally {
            setCargando(false);
        }
    };

    console.log("===================== informacionDetalladaProducto =========================", producto);

    const formatCurrency = (value) => {
        const num = Number(value) || 0;
        return '$' + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 });
    };

    const labelStyle = { fontSize: '0.65rem', letterSpacing: '0.07em' };
    const labelClass = 'text-uppercase text-muted fw-semibold mb-1';

    const comisionLabel = producto.idCatDepartamento === 0
        ? 'Sin Comisión'
        : producto.idCatDepartamento === 1
            ? 'Comisión'
            : 'Comisión Parcial 30%';

    const comisionVariant = producto.idCatDepartamento === 0
        ? 'bg-secondary'
        : producto.idCatDepartamento === 1
            ? 'bg-success'
            : 'bg-warning text-dark';

    return (
        <>
            {/* ── Header ───────────────────────────────────── */}
            <Card className="mb-3 shadow-sm">
                <Card.Body className="py-2 px-3">
                    <div className="d-flex align-items-center gap-2">
                        <Button variant="falcon-default" size="sm" onClick={() => editar ? setEditar(false) : navigate(-1)}>
                            <FontAwesomeIcon icon="arrow-left" />
                        </Button>
                        <div className="d-flex align-items-center gap-2 me-auto">
                            {producto.vImagenProducto_Base64
                                ? <img src={imagenProducto.file} alt="" style={{ width: 28, height: 28, borderRadius: 6, objectFit: 'cover' }} />
                                : <i className="bi bi-box-seam text-primary" style={{ fontSize: '1.1rem' }} />
                            }
                            <div>
                                <div className="fw-semibold lh-1" style={{ fontSize: '0.9rem' }}>
                                    {cargando ? 'Cargando...' : (producto.vNombreProducto || `Producto #${id}`)}
                                </div>
                                <div className="text-muted" style={{ fontSize: '0.72rem' }}>Producto #{id}</div>
                            </div>
                        </div>
                        {!editar && !cargando && (
                            <Button variant="primary" size="sm" onClick={() => setEditar(true)}>
                                <i className="bi bi-pencil me-1" />Editar
                            </Button>
                        )}
                        {editar && (
                            <Button variant="falcon-default" size="sm" onClick={() => setEditar(false)}>
                                <i className="bi bi-x me-1" />Cancelar edición
                            </Button>
                        )}
                    </div>
                </Card.Body>
            </Card>

            {cargando ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <div className="mt-2 text-muted" style={{ fontSize: '0.85rem' }}>Cargando producto...</div>
                </div>
            ) : editar ? (
                <AgregarProducto
                    productos={producto}
                    precios={precios}
                    hideHeader={true}
                    onSaved={() => { setEditar(false); informacionDetalladaProducto(); }}
                />
            ) : (
                <>
                    {/* ── Desktop (md+) ────────────────────────────── */}
                    <Row className="g-3 align-items-start d-none d-md-flex">

                        {/* Columna izquierda */}
                        <Col md={4} xl={3}>
                            {/* Imagen */}
                            <Card className="mb-3 shadow-sm">
                                <Card.Body className="p-0">
                                    <div style={{ aspectRatio: '1/1', backgroundColor: '#f0f4f8', borderRadius: '0.5rem', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {imagenProducto.file ? (
                                            <img src={imagenProducto.file} alt={producto.vNombreProducto} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                            <div className="text-center text-muted p-4">
                                                <i className="bi bi-box-seam" style={{ fontSize: '3rem', opacity: 0.25 }} />
                                                <div style={{ fontSize: '0.72rem' }} className="mt-2">Sin imagen</div>
                                            </div>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Especificaciones SAT */}
                            <Card className="mb-3 shadow-sm">
                                <Card.Header className="py-2 px-3 border-bottom">
                                    <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                        <i className="bi bi-receipt me-2 text-primary" />Información SAT
                                    </span>
                                </Card.Header>
                                <Card.Body className="p-3">
                                    <div className="d-flex flex-column gap-2">
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Clave Unidad</div>
                                            <span className="badge bg-soft-primary text-primary me-1">{producto.vClaveUnidadSat || 'N/A'}</span>
                                            {producto.vDescripcion_ClaveUnidad && <span className="text-muted" style={{ fontSize: '0.78rem' }}>{producto.vDescripcion_ClaveUnidad}</span>}
                                        </div>
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Clave Producto/Servicio</div>
                                            <span className="badge bg-soft-success text-success">{producto.vCodigoProductoServicioSat || 'N/A'}</span>
                                        </div>
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Factor IVA</div>
                                            <span className="text-body" style={{ fontSize: '0.85rem' }}>{producto.vTipoFactorIVA || 'Exento'}</span>
                                            {producto.dTasaCuotaIVA > 0 && (
                                                <span className="badge bg-soft-warning text-warning ms-2" style={{ fontSize: '0.72rem' }}>
                                                    {producto.vTipoFactorIVA === 'Tasa' ? (producto.dTasaCuotaIVA * 100).toFixed(0) + '%' : producto.dTasaCuotaIVA}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Registro */}
                            <Card className="shadow-sm">
                                <Card.Body className="p-3">
                                    <div className="d-flex flex-column gap-2" style={{ fontSize: '0.78rem' }}>
                                        {fecha && (
                                            <div>
                                                <i className="bi bi-calendar-plus text-success me-2" />
                                                Registrado el <strong>{fecha}</strong> a las <strong>{hora}</strong>
                                                {producto.vCreatedUser && <div className="text-muted ms-4">por <strong>{producto.vCreatedUser}</strong></div>}
                                            </div>
                                        )}
                                        {producto.vUpdatedUser && (
                                            <div>
                                                <i className="bi bi-pencil text-primary me-2" />
                                                Última edición: <strong>{producto.vUpdatedUser}</strong>
                                            </div>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Columna derecha */}
                        <Col md={8} xl={9}>
                            {/* Info principal */}
                            <Card className="mb-3 shadow-sm">
                                <Card.Body className="p-3">
                                    <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                                        <h4 className="mb-0 fw-bold">{producto.vNombreProducto}</h4>
                                        <span className={`badge ${producto.bIsActive ? 'bg-success' : 'bg-secondary'}`} style={{ flexShrink: 0 }}>
                                            {producto.bIsActive ? 'Disponible' : 'No disponible'}
                                        </span>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                        {(producto.vDescripcionTipoProducto || producto.vTipoProducto) && (
                                            <span className="badge bg-soft-primary text-primary">
                                                {producto.vDescripcionTipoProducto || producto.vTipoProducto}
                                            </span>
                                        )}
                                        {producto.vCodigoBarras && <span className="badge bg-soft-secondary text-secondary"><i className="bi bi-upc me-1" />{producto.vCodigoBarras}</span>}
                                        <span className={`badge ${comisionVariant}`}>{comisionLabel}</span>
                                        {producto.bServicio ? <span className="badge bg-soft-info text-info">Servicio</span> : <span className="badge bg-soft-warning text-warning">Inventariada</span>}
                                        {producto.dExistencia !== undefined && !producto.bServicio && (
                                            <span className="badge bg-soft-dark text-dark">Existencia: {producto.dExistencia}</span>
                                        )}
                                    </div>
                                    {/* Grid de especificaciones */}
                                    <Row className="g-2">
                                        {producto.idCatTipoLicencia && (
                                            <Col xs={6} md={4}>
                                                <div className={labelClass} style={labelStyle}>Tipo Licencia</div>
                                                <div style={{ fontSize: '0.85rem' }}>{producto.vDescripcionTipo}</div>
                                            </Col>
                                        )}
                                        {producto.idModuloVinculado && (
                                            <Col xs={6} md={4}>
                                                <div className={labelClass} style={labelStyle}>Módulo Vinculado</div>
                                                <div style={{ fontSize: '0.85rem' }}>
                                                    {producto.vClaveModulo && <span className="fw-bold me-1">Clave: {producto.vClaveModulo} -</span>}
                                                    {producto.vDescripcionModulo || `#${producto.idModuloVinculado}`}
                                                </div>
                                            </Col>
                                        )}
                                        {producto.iCantidadTimbres > 0 && (
                                            <Col xs={6} md={4}>
                                                <div className={labelClass} style={labelStyle}>Timbres</div>
                                                <div style={{ fontSize: '0.85rem' }}>{producto.iCantidadTimbres}</div>
                                             </Col>
                                        )}
                                      
                                        
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Precios */}
                            <Card className="shadow-sm">
                                <Card.Header className="py-2 px-3 border-bottom">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <span className="fw-semibold" style={{ fontSize: '0.82rem' }}>
                                            <i className="bi bi-tags me-2 text-primary" />Estructura de Precios
                                        </span>
                                        <div className="d-flex gap-1">
                                            {['MXN', 'USD'].map(moneda => (
                                                <button
                                                    key={moneda}
                                                    className={`btn btn-sm py-0 px-2 ${tabMonedaDetalle === moneda ? 'btn-primary' : 'btn-falcon-default'}`}
                                                    style={{ fontSize: '0.72rem' }}
                                                    onClick={() => setTabMonedaDetalle(moneda)}
                                                >
                                                    {moneda}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="p-3">
                                    {(() => {
                                        const preciosFiltrados = precios.filter(p => p.vMoneda === tabMonedaDetalle);
                                        return preciosFiltrados.length > 0 ? (
                                            <div className="d-flex flex-column gap-3">
                                                {preciosFiltrados.map((precio, index) => {
                                                    const total = Number(precio.dTotal ?? 0);
                                                    const base = Number(precio.dPrecioUnitario ?? 0);
                                                    const iva = Number(precio.dIVA ?? 0);
                                                    return (
                                                        <div key={index} className="border rounded-3 overflow-hidden">
                                                            <div style={{ height: 4, backgroundColor: '#2c7be5' }} />
                                                            <div className="p-3">
                                                                <div className="fw-semibold mb-2" style={{ fontSize: '0.88rem' }}>
                                                                    {precio.bIsPeriodicidad
                                                                        ? precio.descripcion === 'Mensual'
                                                                            ? <><i className="bi bi-calendar-month me-2 text-primary" />Mensual</>
                                                                            : <><i className="bi bi-calendar-year me-2 text-primary" />{precio.descripcion}</>
                                                                        : <><i className="bi bi-bag me-2 text-primary" />Pago Único</>
                                                                    }
                                                                </div>
                                                                <div className="d-flex align-items-end gap-4">
                                                                    <div>
                                                                        <div className="text-primary fw-bold" style={{ fontSize: '1.8rem', lineHeight: 1 }}>{formatCurrency(total)}</div>
                                                                        <div className="text-muted" style={{ fontSize: '0.7rem' }}>Precio Total ({precio.vMoneda})</div>
                                                                    </div>
                                                                    <div className="d-flex gap-4">
                                                                        <div>
                                                                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>Precio Base</div>
                                                                            <div className="fw-semibold text-success" style={{ fontSize: '0.95rem' }}>{formatCurrency(base)}</div>
                                                                        </div>
                                                                        {iva > 0 && (
                                                                            <div>
                                                                                <div className="text-muted" style={{ fontSize: '0.7rem' }}>IVA</div>
                                                                                <div className="fw-semibold text-success" style={{ fontSize: '0.95rem' }}>{formatCurrency(iva)}</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="text-center py-4 text-muted" style={{ fontSize: '0.85rem' }}>
                                                <i className="bi bi-tag me-2 opacity-50" />
                                                Sin precios configurados en {tabMonedaDetalle}
                                            </div>
                                        );
                                    })()}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* ── Móvil (< md) ─────────────────────────────── */}
                    <div className="d-md-none">

                        {/* Hero: imagen + nombre + badges */}
                        <Card className="mb-2 shadow-sm">
                            <Card.Body className="p-3">
                                <div className="d-flex gap-3 align-items-center">
                                    <div style={{ width: 64, height: 64, borderRadius: 10, overflow: 'hidden', backgroundColor: '#f0f4f8', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {imagenProducto.file
                                            ? <img src={imagenProducto.file} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            : <i className="bi bi-box-seam text-muted" style={{ fontSize: '1.6rem', opacity: 0.3 }} />
                                        }
                                    </div>
                                    <div className="flex-grow-1 min-w-0">
                                        <h6 className="mb-1 fw-bold text-truncate">{producto.vNombreProducto}</h6>
                                        <div className="d-flex flex-wrap gap-1">
                                            {producto.vTipoProducto && <span className="badge bg-soft-primary text-primary" style={{ fontSize: '0.68rem' }}>{producto.vTipoProducto}</span>}
                                            <span className={`badge ${producto.bIsActive ? 'bg-success' : 'bg-secondary'}`} style={{ fontSize: '0.68rem' }}>{producto.bIsActive ? 'Disponible' : 'No disponible'}</span>
                                            <span className={`badge ${comisionVariant}`} style={{ fontSize: '0.68rem' }}>{comisionLabel}</span>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Precios accordion */}
                        <Card className="mb-2 shadow-sm overflow-hidden">
                            <div
                                className="d-flex align-items-center justify-content-between p-3"
                                onClick={() => setActiveSection(activeSection === 'precios' ? null : 'precios')}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="min-w-0 me-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-tags text-primary" />
                                        <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Estructura de Precios</span>
                                    </div>
                                    {activeSection !== 'precios' && (
                                        <div className="mt-1">
                                            {precios && precios.length > 0
                                                ? <div className="d-flex flex-wrap gap-1">{precios.map((p, i) => <span key={i} className="badge bg-primary" style={{ fontSize: '0.68rem' }}>{p.vMoneda} {p.descripcion}</span>)}</div>
                                                : <span className="text-muted fst-italic" style={{ fontSize: '0.78rem' }}>Sin precios</span>
                                            }
                                        </div>
                                    )}
                                </div>
                                <i className={`bi bi-chevron-${activeSection === 'precios' ? 'up' : 'down'} text-muted`} />
                            </div>
                            <Collapse in={activeSection === 'precios'}>
                                <div>
                                    <div className="px-3 pb-3 pt-2 border-top">
                                        {/* MXN / USD toggle */}
                                        <div className="d-flex gap-1 mb-3">
                                            {['MXN', 'USD'].map(moneda => (
                                                <button
                                                    key={moneda}
                                                    className={`btn btn-sm py-0 px-2 ${tabMonedaDetalle === moneda ? 'btn-primary' : 'btn-falcon-default'}`}
                                                    style={{ fontSize: '0.72rem' }}
                                                    onClick={e => { e.stopPropagation(); setTabMonedaDetalle(moneda); }}
                                                >
                                                    {moneda}
                                                </button>
                                            ))}
                                        </div>
                                        {(() => {
                                            const preciosFiltrados = precios.filter(p => p.vMoneda === tabMonedaDetalle);
                                            return preciosFiltrados.length > 0
                                                ? <div className="d-flex flex-column gap-3">
                                                    {preciosFiltrados.map((precio, index) => {
                                                        const total = Number(precio.dTotal ?? 0);
                                                        const base = Number(precio.dPrecioUnitario ?? 0);
                                                        const iva = Number(precio.dIVA ?? 0);
                                                        return (
                                                            <div key={index} className="border rounded-3 overflow-hidden">
                                                                <div style={{ height: 3, backgroundColor: '#2c7be5' }} />
                                                                <div className="p-2">
                                                                    <div className="fw-semibold mb-1" style={{ fontSize: '0.82rem' }}>
                                                                        {precio.bIsPeriodicidad
                                                                            ? precio.descripcion === 'Mensual'
                                                                                ? <><i className="bi bi-calendar-month me-1 text-primary" />Mensual</>
                                                                                : <><i className="bi bi-calendar-year me-1 text-primary" />{precio.descripcion}</>
                                                                            : <><i className="bi bi-bag me-1 text-primary" />Pago Único</>
                                                                        }
                                                                    </div>
                                                                    <div className="text-primary fw-bold" style={{ fontSize: '1.4rem', lineHeight: 1 }}>{formatCurrency(total)}</div>
                                                                    <div className="d-flex gap-3 mt-1">
                                                                        <div>
                                                                            <div className="text-muted" style={{ fontSize: '0.68rem' }}>Base</div>
                                                                            <div className="text-success fw-semibold" style={{ fontSize: '0.82rem' }}>{formatCurrency(base)}</div>
                                                                        </div>
                                                                        {iva > 0 && (
                                                                            <div>
                                                                                <div className="text-muted" style={{ fontSize: '0.68rem' }}>IVA</div>
                                                                                <div className="text-success fw-semibold" style={{ fontSize: '0.82rem' }}>{formatCurrency(iva)}</div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                : <div className="text-muted fst-italic" style={{ fontSize: '0.82rem' }}>Sin precios en {tabMonedaDetalle}</div>;
                                        })()}
                                    </div>
                                </div>
                            </Collapse>
                        </Card>

                        {/* SAT accordion */}
                        <Card className="mb-2 shadow-sm overflow-hidden">
                            <div
                                className="d-flex align-items-center justify-content-between p-3"
                                onClick={() => setActiveSection(activeSection === 'sat' ? null : 'sat')}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="min-w-0 me-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-receipt text-primary" />
                                        <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Información SAT</span>
                                    </div>
                                    {activeSection !== 'sat' && (
                                        <div className="mt-1 d-flex gap-1 flex-wrap">
                                            {producto.vClaveUnidadSat
                                                ? <span className="badge bg-soft-primary text-primary" style={{ fontSize: '0.68rem' }}>{producto.vClaveUnidadSat}</span>
                                                : <span className="text-muted fst-italic" style={{ fontSize: '0.78rem' }}>Clave pendiente</span>
                                            }
                                            {producto.vCodigoProductoServicioSat && <span className="badge bg-soft-success text-success" style={{ fontSize: '0.68rem' }}>{producto.vCodigoProductoServicioSat}</span>}
                                        </div>
                                    )}
                                </div>
                                <i className={`bi bi-chevron-${activeSection === 'sat' ? 'up' : 'down'} text-muted`} />
                            </div>
                            <Collapse in={activeSection === 'sat'}>
                                <div>
                                    <div className="px-3 pb-3 pt-2 border-top d-flex flex-column gap-2">
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Clave Unidad</div>
                                            <span className="badge bg-soft-primary text-primary me-1">{producto.vClaveUnidadSat || 'N/A'}</span>
                                            {producto.vDescripcion_ClaveUnidad && <span className="text-muted" style={{ fontSize: '0.78rem' }}>{producto.vDescripcion_ClaveUnidad}</span>}
                                        </div>
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Clave Producto/Servicio</div>
                                            <span className="badge bg-soft-success text-success">{producto.vCodigoProductoServicioSat || 'N/A'}</span>
                                        </div>
                                        <div>
                                            <div className={labelClass} style={labelStyle}>Factor IVA</div>
                                            <strong style={{ fontSize: '0.85rem' }}>{producto.vTipoFactorIVA || 'Exento'}</strong>
                                            {producto.dTasaCuotaIVA > 0 && (
                                                <span className="badge bg-soft-warning text-warning ms-2" style={{ fontSize: '0.68rem' }}>
                                                    {producto.vTipoFactorIVA === 'Tasa' ? (producto.dTasaCuotaIVA * 100).toFixed(0) + '%' : producto.dTasaCuotaIVA}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </Card>

                        {/* Info accordion */}
                        <Card className="mb-3 shadow-sm overflow-hidden">
                            <div
                                className="d-flex align-items-center justify-content-between p-3"
                                onClick={() => setActiveSection(activeSection === 'info' ? null : 'info')}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="min-w-0 me-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-info-circle text-primary" />
                                        <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>Información Adicional</span>
                                    </div>
                                    {activeSection !== 'info' && fecha && (
                                        <div className="text-muted mt-1" style={{ fontSize: '0.75rem' }}>Registrado el {fecha}</div>
                                    )}
                                </div>
                                <i className={`bi bi-chevron-${activeSection === 'info' ? 'up' : 'down'} text-muted`} />
                            </div>
                            <Collapse in={activeSection === 'info'}>
                                <div>
                                    <div className="px-3 pb-3 pt-2 border-top d-flex flex-column gap-2" style={{ fontSize: '0.82rem' }}>
                                        {producto.vCodigoBarras && <div><span className={labelClass} style={labelStyle}>Cód. Barras </span><strong>{producto.vCodigoBarras}</strong></div>}
                                        {producto.idCatTipoLicencia && <div><span className={labelClass} style={labelStyle}>Tipo Licencia </span><strong>{producto.vDescripcionTipo || `#${producto.idCatTipoLicencia}`}</strong></div>}
                                        {producto.idModuloVinculado && <div><span className={labelClass} style={labelStyle}>Módulo </span><strong>{producto.vClaveModulo ? `Clave: ${producto.vClaveModulo} - ` : ''}{producto.vDescripcionModulo || `#${producto.idModuloVinculado}`}</strong></div>}
                                        {producto.iCantidadTimbres > 0 && <div><span className={labelClass} style={labelStyle}>Timbres </span><strong>{producto.iCantidadTimbres}</strong></div>}
                                        {fecha && (
                                            <div className="mt-1">
                                                <i className="bi bi-calendar-plus text-success me-1" />
                                                Registrado el <strong>{fecha}</strong> a las <strong>{hora}</strong>
                                                {producto.vCreatedUser && <div className="ms-3 text-muted">por <strong>{producto.vCreatedUser}</strong></div>}
                                            </div>
                                        )}
                                        {producto.vUpdatedUser && (
                                            <div>
                                                <i className="bi bi-pencil text-primary me-1" />
                                                Última edición: <strong>{producto.vUpdatedUser}</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Collapse>
                        </Card>

                    </div>
                </>
            )}
        </>
    );
};

export default DetalleProducto;
